import React from "react";

const SubmissionsIcon = ({ fill }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="35.577"
      height="27.939"
      viewBox="0 0 35.577 27.939"
    >
      <path
        id="db22"
        d="M39.577,7.075a1.056,1.056,0,0,0-.325-.76A1.131,1.131,0,0,0,38.465,6H25.124a1.075,1.075,0,1,0,0,2.149H38.465a1.131,1.131,0,0,0,.786-.315,1.056,1.056,0,0,0,.325-.76Zm0,6.447a1.056,1.056,0,0,0-.325-.76,1.131,1.131,0,0,0-.786-.315H25.124a1.075,1.075,0,1,0,0,2.149H38.465a1.131,1.131,0,0,0,.786-.315A1.056,1.056,0,0,0,39.577,13.522Zm0,6.447a1.056,1.056,0,0,0-.325-.76,1.131,1.131,0,0,0-.786-.315H25.124a1.075,1.075,0,1,0,0,2.149H38.465a1.131,1.131,0,0,0,.786-.315,1.056,1.056,0,0,0,.325-.76Zm0,6.447a1.056,1.056,0,0,0-.325-.76,1.131,1.131,0,0,0-.786-.315H5.112a1.075,1.075,0,1,0,0,2.149H38.465a1.131,1.131,0,0,0,.786-.315A1.056,1.056,0,0,0,39.577,26.417Zm0,6.447a1.056,1.056,0,0,0-.325-.76,1.131,1.131,0,0,0-.786-.315H5.112a1.075,1.075,0,1,0,0,2.149H38.465a1.131,1.131,0,0,0,.786-.315A1.056,1.056,0,0,0,39.577,32.864ZM17.341,21.044H6.224A2.187,2.187,0,0,1,4,18.895V8.149A2.187,2.187,0,0,1,6.224,6H17.341a2.187,2.187,0,0,1,2.224,2.149V18.895A2.187,2.187,0,0,1,17.341,21.044Z"
        transform="translate(-4 -6)"
        fill={fill ? fill : "#fff"}
      />
    </svg>
  );
};

export default SubmissionsIcon;
